<template>
  <EditorPopover
    ref="popover"
    :actionButtons="actionButtons"
    :title="title"
    @cancel="cancelEditing"
    @action="onAction">

    <div class="row">
      <div class="col-6">
        <div class="row">
          <label class="col-form-label col-2">Width</label>
          <div class="col-10">
            <FormInputText ref="numberInput" type="number" v-model="width" addon="mm" />
          </div>
        </div>
        <div class="row">
          <label class="col-form-label col-2">Height</label>
          <div class="col-10">
            <FormInputText ref="numberInput" type="number" v-model="height" addon="mm" />
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="row">
          <label class="col-form-label col-2">Angle</label>
          <div class="col-10">
            <FormInputText ref="numberInput" type="number" v-model="angle" />
          </div>
        </div>        
      </div>
    </div>

  </EditorPopover>
</template>


<script>
import _ from 'lodash'
import EditorPopover from '@glass-designer/components/editorPopover'
import EditorKeypad from '@glass-designer/components/editorKeypad'
import EditorTypes from '@glass-designer/types'
import MathsUtils from '@/utils/mathsUtils'

export default {
  name: 'EditorShapeToolPopover',
  components: {
    EditorPopover,
    EditorKeypad
  },
  props: {
    editingEnabled: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      actionButtons: [],
      title: '',
      toolInfoText: '',
      angle: 0,
      width: 0,
      height: 0
    }
  },
  watch: {
    angle: function() {
      this.debouncedUpdateTool()
    },
    width: function() {
      this.debouncedUpdateTool()
    },
    height: function() {
      this.debouncedUpdateTool()
    },
  },
  created() {
    this.debouncedUpdateTool = _.debounce(this._updateTool, 100)
  },
  methods: {
    setup(editor, options) {
      this.clearOptions()

      options = _.defaults(options, {
        actionButtons: [],
        title: ''
      })

      this.actionButtons = options.actionButtons
      this.title = options.title
      this.angle = MathsUtils.roundNumber(options.angle || 0, 2)
      this.width = MathsUtils.roundNumber(options.width || 0, 0)
      this.height = MathsUtils.roundNumber(options.height || 0, 0)

      // Setup callbacks next tick so they don't get called when resetting values
      this.callbackContext = options.context
      this.updateCallback = options.updateCallback
      this.applyCallback = options.applyCallback
      this.cancelCallback = options.cancelCallback
    },
    clearOptions() {
      this.callbackContext = null
      this.updateCallback = null
      this.applyCallback = null
      this.cancelCallback = null
    },
    displayToolPopover(containerEl, editor, displayOptions) {
      this.$refs.popover.displayToolPopover(containerEl, editor, displayOptions)
    },
    viewportUpdated(containerEl, editor) {
    },
    hide() {
      if(this.cancelCallback) {
        // Reset cancel CB so it only is called once when hiding popovers
        let cancelCB = this.cancelCallback
        this.cancelCallback = null

        cancelCB(this.callbackContext, false)
      }

      this.clearOptions()
      this.$refs.popover.hide()
    },
    cancelEditing() {
      if(this.cancelCallback)
        this.cancelCallback(this.callbackContext, true)

      this.clearOptions()
      this.hide()
    },
    _updateTool() {
      this.updateTool({ apply: false })
    },
    onAction(eventInfo) {
      this.updateTool({ apply: true, actionTag: eventInfo })
    },
    updateTool(options = {}) {
      try {

        if(options.apply) {
          if(this.applyCallback) {
            this.applyCallback(this.callbackContext, {
              actionTag: options.actionTag
            })
            this.hide()
          }
        } else {
          if(this.updateCallback) {
            this.updateCallback(this.callbackContext, {
              angle: this.angle,
              width: this.width,
              height: this.height
            })
          }
        }

      } catch(err) {
        console.error(err)
        //this.errorText = `${err.message}`
      }

    }
  }
}
</script>